import ErrorIcon from "@/components/_icons/errorIcon";

export const GiftCardCartOrdersBanner = () => {
  return (
    <div className="rounded-md bg-[#FFEDED] border-[#E70000] border-[1px] py-2 px-3 flex gap-1">
      <ErrorIcon height={20} width={20} />
      <span className="ml-4 text-base">
        We are currently not accepting online orders. Remove all non-gift card
        items to continue checkout.
      </span>
    </div>
  );
};
